document.addEventListener('DOMContentLoaded', () => {
  const isHome = window.location.pathname === '/';
  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  /* Conversion fixes: scoped styles, kept separate from Horizon's core CSS. */
  const conversionStyles = document.createElement('style');
  conversionStyles.id = 'sc-conversion-fixes';
  conversionStyles.textContent = `
    .sc-delivery-note {
      margin: 12px 0 4px;
      padding: 12px 14px;
      border: 1px solid rgba(201,118,50,.42);
      border-radius: 12px;
      background: rgba(255,255,255,.06);
      font-size: 13px;
      line-height: 1.45;
    }
    .sc-delivery-note strong { display:block; margin-bottom:3px; }
    .sc-delivery-note a { text-decoration:underline; text-underline-offset:2px; }
    .sc-hide-giveaway-on-product { display:none !important; }

    @media(max-width:749px){
      #MainContent > [id$="__hero_jVaWmY"] .hero__container {
        padding-block: 14px 16px !important;
      }
      #MainContent > [id$="__hero_jVaWmY"] .hero__content-wrapper {
        gap: 7px !important;
      }
      #MainContent > [id$="__hero_jVaWmY"] .hero__content-wrapper > *:nth-child(1) {
        padding-block-end: 6px !important;
      }
      #MainContent > [id$="__hero_jVaWmY"] .hero__content-wrapper > *:nth-child(2) {
        padding-block: 3px !important;
      }
      #MainContent > [id$="__hero_jVaWmY"] .hero__content-wrapper > *:nth-child(2) :is(h1,h2,h3,p,span) {
        font-size: clamp(1.9rem, 10vw, 2.55rem) !important;
        line-height: 1 !important;
      }
      #MainContent > [id$="__hero_jVaWmY"] .hero__content-wrapper > *:nth-child(4) {
        display:none !important;
      }
    }

    /* BundleX / volume-discount contrast fallback. */
    [id*="bundlex" i], [class*="bundlex" i],
    [id*="volume-discount" i], [class*="volume-discount" i] {
      --sc-bundle-readable: #ffffff;
    }
    [id*="bundlex" i] :is(label,span,p,strong,small,button),
    [class*="bundlex" i] :is(label,span,p,strong,small,button),
    [id*="volume-discount" i] :is(label,span,p,strong,small,button),
    [class*="volume-discount" i] :is(label,span,p,strong,small,button) {
      color: var(--sc-bundle-readable) !important;
    }
  `;
  document.head.appendChild(conversionStyles);

  /* The hero promise now points to a real collection built from recent paid sales. */
  if (isHome) {
    const bestSellerButton = Array.from(document.querySelectorAll('a')).find((link) =>
      link.textContent.trim().toLowerCase().includes('shop best sellers')
    );
    if (bestSellerButton) bestSellerButton.setAttribute('href', '/collections/best-sellers');

    /* On phones, put something buyable immediately after the trust strip instead of
       making shoppers scroll through the founder story before seeing a product. */
    if (isMobile) {
      const trustStrip = document.querySelector('#MainContent > [id$="__section_tVehXj"]');
      const featuredProduct = document.querySelector('#MainContent > [id$="__featured_product_information_kJbRLM"]');
      if (trustStrip && featuredProduct) trustStrip.insertAdjacentElement('afterend', featuredProduct);
    }
  }

  /* Hide Judge.me preview stars when the product has no reviews yet. */
  const syncJudgeMePreviewBadges = () => {
    document.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      const rawCount = badge.getAttribute('data-number-of-reviews');
      const reviewCount = Number.parseInt(rawCount || '0', 10);
      const wrapper = badge.closest('.jdgm-preview-badge');
      const target = wrapper || badge;

      if (reviewCount > 0) {
        target.style.removeProperty('display');
        target.removeAttribute('aria-hidden');
      } else {
        target.style.setProperty('display', 'none', 'important');
        target.setAttribute('aria-hidden', 'true');
      }
    });
  };

  syncJudgeMePreviewBadges();

  const judgeMeObserver = new MutationObserver(() => syncJudgeMePreviewBadges());
  judgeMeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-number-of-reviews']
  });

  const productMain = document.querySelector('main[data-template^="product"]');
  if (!productMain) return;

  /* Verified delivery guidance from the store's Shipping Policy. */
  const addDeliveryNote = () => {
    if (productMain.querySelector('.sc-delivery-note')) return;
    const addButton = productMain.querySelector('.add-to-cart-button');
    if (!addButton) return;

    const anchor = addButton.closest('product-form') ||
      addButton.closest('.buy-buttons-block') ||
      addButton.parentElement;
    if (!anchor) return;

    const note = document.createElement('div');
    note.className = 'sc-delivery-note';
    note.innerHTML = `
      <strong>Made to order & delivery</strong>
      Processing: 2–7 business days. Estimated delivery after dispatch: Australia 5–15 business days · New Zealand 7–20 · International 10–30. Shipping charges are shown at checkout. <a href="/policies/shipping-policy">Full shipping details</a>.
    `;
    anchor.insertAdjacentElement('afterend', note);
  };

  addDeliveryNote();
  window.setTimeout(addDeliveryNote, 600);

  /* Fix low-contrast multi-buy choices even when the app changes its generated class names. */
  const fixBundleContrast = () => {
    const explicitContainers = productMain.querySelectorAll(
      '[id*="bundlex" i], [class*="bundlex" i], [id*="volume-discount" i], [class*="volume-discount" i]'
    );

    explicitContainers.forEach((container) => {
      container.querySelectorAll('label,span,p,strong,small,button,div').forEach((el) => {
        const style = window.getComputedStyle(el);
        const rgb = style.color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return;
        const [r,g,b] = rgb.slice(0,3).map(Number);
        const luminance = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
        if (luminance < .45) el.style.setProperty('color', '#ffffff', 'important');
      });
    });

    if (!explicitContainers.length) {
      const candidates = Array.from(productMain.querySelectorAll('div,section')).filter((el) => {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > 0 && text.length < 900 && /buy\s*[234]|multi[- ]?buy|volume discount|save\s*\d+%/i.test(text);
      });
      const container = candidates.sort((a,b) => a.textContent.length - b.textContent.length)[0];
      if (container) {
        const bg = window.getComputedStyle(container).backgroundColor.match(/\d+/g);
        if (bg && bg.length >= 3) {
          const [r,g,b] = bg.slice(0,3).map(Number);
          const bgLum = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
          if (bgLum < .42) {
            container.querySelectorAll('label,span,p,strong,small,button,div').forEach((el) => {
              const rgb = window.getComputedStyle(el).color.match(/\d+/g);
              if (!rgb || rgb.length < 3) return;
              const [cr,cg,cb] = rgb.slice(0,3).map(Number);
              const textLum = (0.2126*cr + 0.7152*cg + 0.0722*cb) / 255;
              if (textLum < .55) el.style.setProperty('color', '#ffffff', 'important');
            });
          }
        }
      }
    }
  };

  fixBundleContrast();
  window.setTimeout(fixBundleContrast, 800);
  window.setTimeout(fixBundleContrast, 1800);

  if (!isMobile) return;

  /* Product pages: suppress only floating promo/giveaway teasers that collide with the
     sticky purchase bar. Normal inline signup sections are left untouched. */
  const suppressFloatingGiveaway = () => {
    const selectors = '[class*="popup" i],[id*="popup" i],[class*="floating" i],[id*="floating" i],[class*="form" i],[id*="form" i]';
    document.querySelectorAll(selectors).forEach((el) => {
      if (el.closest('#MainContent')) return;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!/(giveaway|10% off|monthly free|subscribe.*win|join.*step)/i.test(text)) return;
      const position = window.getComputedStyle(el).position;
      if (position === 'fixed' || position === 'sticky') el.classList.add('sc-hide-giveaway-on-product');
    });
  };

  suppressFloatingGiveaway();
  window.setTimeout(suppressFloatingGiveaway, 700);
  window.setTimeout(suppressFloatingGiveaway, 1700);

  const getPrimaryButton = () =>
    Array.from(productMain.querySelectorAll('.add-to-cart-button')).find(
      (button) => button.offsetParent !== null
    ) || productMain.querySelector('.add-to-cart-button');

  let primaryButton = getPrimaryButton();
  if (!primaryButton) return;

  const bar = document.createElement('div');
  bar.className = 'sc-mobile-purchase-bar';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = `
    <div class="sc-mobile-purchase-bar__inner">
      <div class="sc-mobile-purchase-bar__title"></div>
      <button type="button" class="sc-mobile-purchase-bar__button"></button>
    </div>
  `;
  document.body.appendChild(bar);

  const stickyButton = bar.querySelector('.sc-mobile-purchase-bar__button');
  const title = bar.querySelector('.sc-mobile-purchase-bar__title');
  const productTitle = productMain.querySelector('h1')?.textContent?.trim() || document.title.split('–')[0].trim();
  title.textContent = productTitle;

  const sync = () => {
    const nextButton = getPrimaryButton();
    if (nextButton) primaryButton = nextButton;
    if (!primaryButton) return;

    stickyButton.textContent = primaryButton.textContent.trim() || 'Add to cart';
    stickyButton.disabled = primaryButton.disabled;
    stickyButton.setAttribute('aria-disabled', primaryButton.disabled ? 'true' : 'false');
  };

  stickyButton.addEventListener('click', () => {
    sync();
    if (!primaryButton || primaryButton.disabled) return;
    primaryButton.click();
  });

  const observer = new IntersectionObserver(
    ([entry]) => {
      const shouldShow = !entry.isIntersecting;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (shouldShow) suppressFloatingGiveaway();
    },
    { threshold: 0.1 }
  );
  observer.observe(primaryButton);

  sync();

  document.addEventListener('change', () => window.setTimeout(sync, 80), true);

  const productObserver = new MutationObserver(() => {
    sync();
    addDeliveryNote();
    fixBundleContrast();
    suppressFloatingGiveaway();
  });
  productObserver.observe(productMain, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'value', 'aria-disabled']
  });
});
